module.exports = "/_next/static/images/fj-ffa1d9ec4d49a98a76bb143f1cc52582.svg";